import { memo } from 'react';
import { Link } from 'react-router-dom';

import { Td } from '@frontend/legacy-components';

import type { ColumnConfig } from '../types';

export type DataRowCellProps<
  ColumnId extends string,
  RowData extends Record<string, unknown>,
> = {
  column: ColumnConfig<ColumnId, RowData>;
  rowData: RowData;
  isStickyLeftColumn: boolean;
  isHighlighted?: boolean;
  rowLinkDestination: string;
};

export const DataRowCell = <
  ColumnId extends string,
  RowData extends Record<string, unknown>,
>({
  column: { render, width, horizontalAlignment },
  rowData,
  isStickyLeftColumn,
  isHighlighted,
  rowLinkDestination,
}: DataRowCellProps<ColumnId, RowData>) => {
  const optionalProps = {
    ...(isStickyLeftColumn && {
      position: 'sticky',
      zIndex: 1,
      left: 0,
      borderRightWidth: 1,
      sx: {
        ':not(:last-of-type)': {
          borderRightWidth: 1,
        },
      },
    }),
    ...(isHighlighted && {
      backgroundColor: 'interaction.surfaceHover',
    }),
  };
  return (
    <Td
      as={Link}
      innerProps={{ to: rowLinkDestination }}
      width={width}
      justifyContent={horizontalAlignment}
      textAlign={horizontalAlignment ?? 'start'}
      wordBreak="normal"
      overflowWrap="anywhere"
      {...optionalProps}
    >
      {render(rowData)}
    </Td>
  );
};

export const MemoizedDataRowCell = memo(DataRowCell);
